import api from '@/api';
import { getMetaInfo } from '@/lib/request/index';
import { ORDER_STATE_MAP, ORDER_STATUS } from '@/const/entrega';

const state = {
  errno: 0,
  loading: false,

  pageStatus: '', // 页面状态 1进行中 2取消 3已完成
  orderStatus: '', // 订单状态码
  orderData: {}, // 订单信息
  receivedCode: {}, // 收件码信息
  orderDesc: {}, // 订单说明卡片
  riderInfo: {}, // 骑手信息

  serverApiTime: 0,
};

const mutations = {
  /** @desc 获取订单页信息 */
  setPageInfo(state, data) {
    const {
      pageStatus = -1,
      orderData = {},
      receivedCode = {},
      orderDesc = {},
      riderInfo = {},
    } = data;

    if (pageStatus === ORDER_STATE_MAP.complete) {
      state.orderStatus = ORDER_STATUS.FLASH_FINISH;
    } else if (pageStatus === ORDER_STATE_MAP.cancel) {
      state.orderStatus = ORDER_STATUS.FLASH_ABNORMAL;
    } else {
      state.orderStatus = orderData?.status;
    }

    state.pageStatus = pageStatus;
    state.orderData = orderData;
    state.receivedCode = receivedCode;
    state.orderDesc = orderDesc;
    state.riderInfo = riderInfo;

    state.serverApiTime = getMetaInfo(data)?.time;
  },
};

const actions = {
  /** @desc 获取订单页信息 */
  async getOrderDetailInfo({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.apiEntregaOrderDetail(param);
      commit('setPageInfo', res);
      state.errno = 0;
      state.loading = false;
      return res
    } catch (err) {
      state.errno = err.errno;
      state.loading = false;
      return err?.data
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
